import React, { useEffect } from 'react';

const CookiePolicy = () => {
  useEffect(() => {
    // Load the GetTerms embed script for cookie policy
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'getterms-embed-js';
    script.src = 'https://gettermscdn.com/dist/js/embed.js';
    
    // Check if script already exists
    if (!document.getElementById('getterms-embed-js')) {
      const ref = document.getElementsByTagName('script')[0];
      if (ref) {
        ref.parentNode.insertBefore(script, ref);
      } else {
        document.head.appendChild(script);
      }
    }

    return () => {
      // Clean up script when component unmounts
      const existingScript = document.getElementById('getterms-embed-js');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <section className="py-24 min-h-screen">
      <div className="max-w-4xl mx-auto px-6">
        <div className="space-y-8">
          <h1 className="text-4xl md:text-5xl font-serif text-slate-100 mb-6">C</h1>
          <div className="w-16 h-px bg-amber-400 mx-auto mb-8" />
          
          <div 
            className="getterms-document-embed bg-slate-800/50 rounded-lg p-8 min-h-[600px]"
            data-getterms="JPOHP"
            data-getterms-document="cookies"
            data-getterms-lang="en-us"
            data-getterms-mode="direct"
            data-getterms-env="https://gettermscdn.com"
          >
            <div className="text-slate-400 text-center py-12">
              Loading Cookie Policy...
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CookiePolicy;